import React, { useEffect, useRef, useState } from 'react'
import { useReactToPrint } from 'react-to-print';
import { Constent } from '../../../../../Assets/Constants/Constent';
import { OtherImages } from '../../../../../Assets/Images/CelcomOtherImages';
import { AfterCopyIcon, ConfirmTickIcon, CopyIcon, DownloadIcon } from '../../../../../Assets/Images/CelcomSvgImages';
import { ConfirmationBackBtn } from '../../../../Common/Button';

const AssignActivityConfirmationBodyContent = ({ pageState, userDataObj, selectedWorkOrderItem }) => {
    const [downloadBtnState, setDownloadBtnState] = useState(false);
    const [copyState, setCopyState] = useState(false);
    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        onAfterPrint: () => {
            setDownloadBtnState(false);
        }
    });

    const downloadPdfFun = () => {
        setDownloadBtnState(true);
    }
    useEffect(() => {
        if (downloadBtnState) {
            handlePrint();
        }
    }, [downloadBtnState]);

    return (
        <div className='body-content-section pt-0' ref={componentRef}>
            <div className="assign-workorder-confirmation-section">
                <div className="workorder-confirmation-section"></div>
                <div className="workorder-confirmation-section">
                    {
                        downloadBtnState && <img src={OtherImages.CelcomDigiLogo} style={{ right: 24, top: 20 }} className="position-absolute" />
                    }
                    {
                        !downloadBtnState && <div className="download-btn-section" onClick={downloadPdfFun}>
                            <span>{Constent.DOWNLOAD_BTN}</span>
                            <DownloadIcon />
                        </div>
                    }
                    <div className={`workorder-confirmation-content-section ${downloadBtnState ? "pt-6" : ""}`}>
                        <ConfirmTickIcon />
                        <div className="wrapper-workorder-confirmation-content-section">
                            <div className="confirmation-content-item mt-3">
                                {`${Constent.BODY_HEADER_DASHBORD_BANNAR_SUB_TEXT} ${userDataObj?.userData?.activeUserData?.userData?.firstName}`}
                            </div>
                            <div className="confirmation-content-item mt-1">
                                {pageState?.displayMsg}
                            </div>
                            <div className="confirmation-content-item mt-1 mb-5">
                                {`${Constent.FREE_CONTENT_TEXT1}`}
                                <span>{selectedWorkOrderItem?.itemId?.replaceAll("FieldActivity-", "") || selectedWorkOrderItem?.id?.replaceAll("FieldActivity-", "")}</span>
                                &nbsp;&nbsp;
                                <span role="button" onClick={() => (navigator.clipboard.writeText(selectedWorkOrderItem?.itemId?.replaceAll("FieldActivity-", "") || selectedWorkOrderItem?.id?.replaceAll("FieldActivity-", "")), setCopyState(true))}> 
                                    {copyState? <AfterCopyIcon/>:<CopyIcon />}
                                    <span className="confirmation-content-item mt-1 mb-4"></span> 
                                </span>
                            </div>
                        </div>
                        {
                            !downloadBtnState && <ConfirmationBackBtn btnItemName={Constent.HEADER_MENU_ITEM1} btnRoute={"/workorder"} />
                        }
                    </div>
                </div>
                <div className="workorder-confirmation-section"></div>
            </div>
        </div>
    )
}

export default AssignActivityConfirmationBodyContent;